import { render } from "./CategoriasApiTable.vue?vue&type=template&id=1d2b8e41&scoped=true"
import script from "./CategoriasApiTable.vue?vue&type=script&lang=js"
export * from "./CategoriasApiTable.vue?vue&type=script&lang=js"

import "./CategoriasApiTable.vue?vue&type=style&index=0&id=1d2b8e41&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2b8e41"]])

export default __exports__